// src/components/ProductImageCarousel.jsx
import React, { useState, useEffect, useCallback } from "react";
import { Typography, Box, CardMedia, IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosNewIcon from "@mui/icons-material/ArrowForwardIos";
import useEmblaCarousel from "embla-carousel-react";

// Define a standard height for the product card image area (e.g., 200px)
const CAROUSEL_HEIGHT = 200; 

const ProductImageCarousel = ({ product }) => {
  // Good: Ensures images is an array of URLs
  const images = Array.isArray(product.image) ? product.image : [product.image];
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true });

  const goToPrevious = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const goToNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);

  const isCarousel = images.length > 1;

  return (
    // FIX: Add a fixed height to the outer Box container
    <Box
      position="relative"
      sx={{
        width: "100%",
        aspectRatio: "1 / 1",
        overflow: "hidden",
        backgroundColor: "#fff",
      }}
    >
      <Box
        ref={emblaRef}
        sx={{
          height: "100%",
          overflow: "hidden", 
        }}
      >
        <Box
          sx={{
            height: "100%",
            display: "flex",
            userSelect: "none",
            backfaceVisibility: "hidden",
            WebkitTouchCallout: "none",
            WebkitTapHighlightColor: "transparent",
          }}
        >
          {/* Check for empty array to prevent rendering issues */}
          {images.length > 0 ? (
            images.map((image, index) => (
              <Box
                key={index}
                sx={{
                  flex: "0 0 100%",
                  minWidth: 0,
                  height: "100%",
                }}
              >
                <CardMedia
                  component="img"
                  sx={{
                    width: "100%",
                    height: "100%", // Inherits 200px from the parent Box
                    objectFit: "contain",
                  }}
                  image={image}
                  alt={`${product.name} - Image ${index + 1}`}
                />
              </Box>
            ))
          ) : (
            // Fallback content if no image URLs are present
             <Box sx={{ flex: "0 0 100%", display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <Typography variant="caption" color="textSecondary">
                    No Image Available
                </Typography>
            </Box>
          )}
        </Box>
      </Box>

      {isCarousel && (
        <>
          {/* Navigation Icons (unchanged) */}
          <IconButton
            onClick={goToPrevious}
            sx={{
              position: "absolute",
              left: 0,
              top: "50%",
              transform: "translateY(-50%)",
              color: "#cacacaff",
              backgroundColor: "transparent",
              "&:hover": {
                backgroundColor: "transparent",
              },
              zIndex: 1,
            }}
          >
            <ArrowBackIosNewIcon />
          </IconButton>
          <IconButton
            onClick={goToNext}
            sx={{
              position: "absolute",
              right: 0,
              top: "50%",
              transform: "translateY(-50%)",
              color: "#cacacaff",
              backgroundColor: "transparent",
              "&:hover": {
                backgroundColor: "transparent",
              },
              zIndex: 1,
            }}
          >
            <ArrowForwardIosNewIcon />
          </IconButton>
        </>
      )}
    </Box>
  );
};

export default ProductImageCarousel;